import Image from 'next/image'

import {
  ScreenSize,
  SOMETHING_WENT_WRONG,
  SOMETHING_WENT_WRONG_DESCRIPTION
} from '@/app/constants/index'
import { useCurrentBreakpoint } from '@/app/hooks/useCurrentBreakpoint'
import { refreshSession } from '@/app/plugins/refreshTokenStrategy'
import { cn } from '@/app/utils'
import {
  RefreshSessionStatus,
  useServiceErrorsStore
} from '@/components/entities/common/model/service-errors.store'
import EmptyListPlug from '@/components/pages/plugs/EmptyListPlug'
import { AppButton } from '@/components/shared/button'
import { AppLoader } from '@/components/shared/loader'

export const RefreshSessionOverlay = () => {
  const refreshSessionStatus = useServiceErrorsStore(
    state => state.refreshSessionStatus
  )
  const { breakpoint } = useCurrentBreakpoint()
  const isMobileScreen = [ScreenSize.Xxs].includes(breakpoint)

  if (refreshSessionStatus === RefreshSessionStatus.None) {
    return null
  }

  const isButtonLoading = refreshSessionStatus === RefreshSessionStatus.Loading

  const handleRefreshSession = () => {
    if (isButtonLoading) {
      return
    }
    refreshSession()
  }

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-grey-10">
      <div className="flex h-full flex-col items-center justify-center">
        <EmptyListPlug
          image={
            <Image
              src="/images/shared/something-went-wrong.png"
              width={isMobileScreen ? 90 : 120}
              height={isMobileScreen ? 90 : 120}
              alt="image"
            />
          }
          title={SOMETHING_WENT_WRONG}
          description={
            <span className="block w-full">
              {SOMETHING_WENT_WRONG_DESCRIPTION}
            </span>
          }
          withGoToMainButton={false}
          className="mt-0"
          titleClassName={cn('mb-8 text-24', 'sm:mb-4 xxs:text-16')}
          descriptionClassName="w-full text-grey-60 text-20 sm:text-16"
          buttonComponent={
            <AppButton
              variant="secondary"
              size="large"
              className={cn(
                'w-[188px] lg:!h-[48px] lg:w-[128px]',
                isButtonLoading && 'cursor-not-allowed'
              )}
              onClick={handleRefreshSession}
            >
              {isButtonLoading ? (
                <AppLoader noText variant="primary" className="scale-50" />
              ) : (
                'Обновить'
              )}
            </AppButton>
          }
        />
      </div>
    </div>
  )
}
